import { render, staticRenderFns } from "./RiskScenarioThreatViewModal.vue?vue&type=template&id=328f088a&"
import script from "./RiskScenarioThreatViewModal.vue?vue&type=script&lang=js&"
export * from "./RiskScenarioThreatViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports